import $ from 'jquery'
import { toolkitUrls } from '@/links'
import { RequestHandler, getCookie } from './helpers'

export {
  getStudents,
  getStudentResources,
  copyCollection,
  getSharedStudent,
  deleteStudentResource,
  getLibraryCountForGoal,
  getLibraryCountForStrategy,
  getRecentStudents,
  addGoalForStudent,
  postStudentContent,
  deleteSavedGoalForStudent,
  deleteSavedStrategyForStudent,
  deleteStudent,
  addStudent,
  updateStudent,
  getLibraryGoal,
  getSharedGoal,
  saveGoalForStudent,
  getSavedStrategy,
  putSavedStrategy,
  addStrategyForStudent,
  getAllResourcesForContentTypes
}

function getStudents(userUuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/collections/customresources/${userUuid}/students`,
    method: 'GET',
    xhrFields: { withCredentials: true }
  })
}

async function getStudentResourcesRequest(studentUuid, params = {}) {
  const queryString = new URLSearchParams(params).toString()
  const gbcs = getCookie('gbcs')
  return fetch(`${toolkitUrls.api}/collections/${studentUuid}?${queryString}`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': gbcs,
    }
  })
}

async function getStudentResources(uuid, params = {}) {
  const handleRequest = RequestHandler.getHandleRequest()
  return handleRequest({requestFn: getStudentResourcesRequest}, uuid, params)
}

function copyCollection(studentUuid, nameOfCopy) {
  return $.ajax({
    url: `${toolkitUrls.api}/collections/${studentUuid}/copy`,
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({ name_of_copy: nameOfCopy }),
    xhrFields: { withCredentials: true }
  }).catch(jqXHR => {
    throw jqXHR.responseJSON
  })
}

function getSharedStudent(shareToken, params = {}) {
  return $.ajax({
    url: `${toolkitUrls.api}/collections/share/${shareToken}?${$.param(params)}`,
    method: 'GET'
  })
}

function deleteStudentResource(studentUuid, contentUuid, resourceType) {
  return $.ajax({
    url: `${toolkitUrls.api}/collections/${studentUuid}/${contentUuid}/${resourceType}`,
    method: 'DELETE',
    xhrFields: { withCredentials: true }
  })
}

function getLibraryGoal(contentUuid, params = {}) {
  var target = `${toolkitUrls.api}/library/goal/${contentUuid}?${$.param(params)}`
  return $.ajax({
    url: target,
    method: 'GET',
    xhrFields: { withCredentials: true }
  })
}

function getSharedGoal(contentUuid, params = {}) {
  var target = `${toolkitUrls.api}/library/shared/goal/${contentUuid}?${$.param(params)}`
  return $.ajax({
    url: target,
    method: 'GET',
    xhrFields: { withCredentials: true }
  })
}

// TODO?: route needs to be updated to use collections in backend
function getLibraryCountForGoal(userUuid, goalUuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/${userUuid}/count/${goalUuid}`,
    method: 'GET',
    xhrFields: { withCredentials: true }
  })
}

function getLibraryCountForStrategy(userUuid, strategyUuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/${userUuid}/source_strategy/${strategyUuid}`,
    method: 'GET',
    xhrFields: { withCredentials: true }
  })
}

// TODO: route needs to be updated to use collections in backend
function getRecentStudents(userUuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/${userUuid}/recent_students`,
    method: 'GET',
    xhrFields: { withCredentials: true }
  })
}

function addGoalForStudentRequest(student, goalPayload) {
  const gbcs = getCookie('gbcs')

  const payload = {
    ...goalPayload,
    student_uuid: student.uuid,
    student_name: student.name,
    for_student: true
  }

  return fetch(`${toolkitUrls.api}/library/goal`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': gbcs,
    },
    body: JSON.stringify(payload)
  })
}

function addGoalForStudent(student, goalPayload) {
  const handleRequest = RequestHandler.getHandleRequest()
  return handleRequest({requestFn: addGoalForStudentRequest}, student, goalPayload)
}

function saveGoalForStudentRequest(studentUuid, savedGoalUuid, goalPayload) {
  const gbcs = getCookie('gbcs')

  return fetch(`${toolkitUrls.api}/library/goal/${savedGoalUuid}`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': gbcs,
    },
    body: JSON.stringify(goalPayload)
  })
}

function saveGoalForStudent(studentUuid, savedGoalUuid, goalPayload) {
  const handleRequest = RequestHandler.getHandleRequest()
  return handleRequest({requestFn: saveGoalForStudentRequest}, studentUuid, savedGoalUuid, goalPayload)
}

function getSavedStrategy(uuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/strategy/${uuid}`,
    method: 'GET',
    xhrFields: { withCredentials: true }
  })
}

function putSavedStrategyRequest(savedStrategy) {
  const gbcs = getCookie('gbcs')

  return fetch(`${toolkitUrls.api}/library/strategy/${savedStrategy.uuid}`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': gbcs,
    },
    body: JSON.stringify(savedStrategy)
  })
}

function putSavedStrategy(savedStrategy) {
  const handleRequest = RequestHandler.getHandleRequest()
  return handleRequest({requestFn: putSavedStrategyRequest}, savedStrategy)
}

function addStrategyForStudentRequest({ userUuid, strategyUuid, studentUuid, studentName, notes }) {
  const gbcs = getCookie('gbcs')

  const payload = {
    user_uuid: userUuid,
    strategy_uuid: strategyUuid,
    student_uuid: studentUuid,
    student_name: studentName,
    notes
  }

  return fetch(`${toolkitUrls.api}/library/strategy`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': gbcs,
    },
    body: JSON.stringify(payload)
  })
}

function addStrategyForStudent({ userUuid, strategyUuid, studentUuid, studentName, notes }) {
  const handleRequest = RequestHandler.getHandleRequest()
  return handleRequest(
    {requestFn: addStrategyForStudentRequest},
    { userUuid, strategyUuid, studentUuid, studentName, notes }
  )
}

function postStudentContentRequest(studentUuid, contentType, contentUuid, contributorUuid) {
  const gbcs = getCookie('gbcs')

  return fetch(`${toolkitUrls.api}/collections/content/add`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': gbcs,
    },
    body: JSON.stringify({
      collection_uuid: studentUuid,
      content_type: contentType,
      content_uuid: contentUuid,
      contributor: contributorUuid
    })
  })
}

function postStudentContent(studentUuid, contentType, contentUuid, contributorUuid) {
  const handleRequest = RequestHandler.getHandleRequest()
  return handleRequest({requestFn: postStudentContentRequest}, studentUuid, contentType, contentUuid, contributorUuid)
}

function deleteSavedGoalForStudent(savedGoalUuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/goal/${savedGoalUuid}`,
    method: 'DELETE',
    xhrFields: { withCredentials: true }
  })
}

function deleteSavedStrategyForStudent(savedStrategyUuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/strategy/${savedStrategyUuid}`,
    method: 'DELETE',
    xhrFields: { withCredentials: true }
  })
}

function deleteStudent(studentUuid, userUuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/${userUuid}/student/${studentUuid}`,
    method: 'DELETE',
    xhrFields: { withCredentials: true }
  })
}

function addStudent(studentName, userUuid) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/${userUuid}/student`,
    method: 'POST',
    data: JSON.stringify({ name: studentName }),
    xhrFields: { withCredentials: true }
  })
}

function updateStudent({ userUuid, studentUuid, updateParams }) {
  return $.ajax({
    url: `${toolkitUrls.api}/library/${userUuid}/student/${studentUuid}`,
    method: 'PUT',
    contentType: 'application/json',
    data: JSON.stringify(updateParams),
    xhrFields: { withCredentials: true }
  })
}

function getAllResourcesForContentTypes(userUuid, contentTypes) {
  contentTypes = encodeURIComponent(contentTypes.join(','))
  return $.ajax({
    url: `${toolkitUrls.api}/library/${userUuid}/allresources/${contentTypes}`,
    method: 'GET',
    xhrFields: { withCredentials: true }
  })
}
